import { render, staticRenderFns } from "./VehicleDetailsReview.vue?vue&type=template&id=3b729b4f"
import script from "./VehicleDetailsReview.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports